export const SIDE_OPTIONS = ["top", "right", "bottom", "left"];
export const ALIGN_OPTIONS = ["start", "center", "end"];
export function getPlacementData(_ref) {
  let {
    anchorRect: p,
    popperSize: c,
    arrowSize: f,
    arrowOffset: l = 0,
    side: d,
    sideOffset: h = 0,
    align: x,
    alignOffset: g = 0,
    shouldAvoidCollisions: u = !0,
    collisionBoundariesRect: w,
    collisionTolerance: m = 0
  } = _ref;
  if (!p || !c || !w) return {
    popperStyles: o,
    arrowStyles: n
  };
  const y = function (e, r) {
      let o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      let i = arguments.length > 4 ? arguments[4] : undefined;
      const p = i ? i.height : 0,
        a = t(r, e, "x"),
        s = t(r, e, "y"),
        c = s.before - o - p,
        f = s.after + o + p,
        l = a.before - o - p,
        d = a.after + o + p;
      return {
        top: {
          start: {
            x: a.start + n,
            y: c
          },
          center: {
            x: a.center,
            y: c
          },
          end: {
            x: a.end - n,
            y: c
          }
        },
        right: {
          start: {
            x: d,
            y: s.start + n
          },
          center: {
            x: d,
            y: s.center
          },
          end: {
            x: d,
            y: s.end - n
          }
        },
        bottom: {
          start: {
            x: a.start + n,
            y: f
          },
          center: {
            x: a.center,
            y: f
          },
          end: {
            x: a.end - n,
            y: f
          }
        },
        left: {
          start: {
            x: l,
            y: s.start + n
          },
          center: {
            x: l,
            y: s.center
          },
          end: {
            x: l,
            y: s.end - n
          }
        }
      };
    }(c, p, h, g, f),
    b = y[d][x];
  if (!1 === u) {
    const t = e(b);
    let o = n;
    f && (o = i({
      popperSize: c,
      arrowSize: f,
      arrowOffset: l,
      side: d,
      align: x
    }));
    return {
      popperStyles: {
        ...t,
        "--radix-popper-transform-origin": r(c, d, x, l, f)
      },
      arrowStyles: o,
      placedSide: d,
      placedAlign: x
    };
  }
  const S = DOMRect.fromRect({
      ...c,
      ...b
    }),
    $ = (O = w, z = m, DOMRect.fromRect({
      width: O.width - 2 * z,
      height: O.height - 2 * z,
      x: O.left + z,
      y: O.top + z
    }));
  var O, z;
  const R = s(S, $),
    M = y[a(d)][x],
    D = function (t, e, r) {
      const o = a(t);
      return e[t] && !r[o] ? o : t;
    }(d, R, s(DOMRect.fromRect({
      ...c,
      ...M
    }), $)),
    A = function (t, e, r, o, n) {
      const i = "top" === r || "bottom" === r,
        p = i ? "left" : "top",
        a = i ? "right" : "bottom",
        s = i ? "width" : "height",
        c = e[s] > t[s];
      if (("start" === o || "center" === o) && (n[p] && c || n[a] && !c)) return "end";
      if (("end" === o || "center" === o) && (n[a] && c || n[p] && !c)) return "start";
      return o;
    }(c, p, d, x, R),
    I = e(y[D][A]);
  let C = n;
  f && (C = i({
    popperSize: c,
    arrowSize: f,
    arrowOffset: l,
    side: D,
    align: A
  }));
  return {
    popperStyles: {
      ...I,
      "--radix-popper-transform-origin": r(c, D, A, l, f)
    },
    arrowStyles: C,
    placedSide: D,
    placedAlign: A
  };
}
function t(t, e, r) {
  const o = t["x" === r ? "left" : "top"],
    n = "x" === r ? "width" : "height",
    i = t[n],
    p = e[n];
  return {
    before: o - p,
    start: o,
    center: o + (i - p) / 2,
    end: o + i - p,
    after: o + i
  };
}
function e(t) {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "max-content",
    willChange: "transform",
    transform: `translate3d(${Math.round(t.x + window.scrollX)}px, ${Math.round(t.y + window.scrollY)}px, 0)`
  };
}
function r(t, e, r, o, n) {
  const i = "top" === e || "bottom" === e,
    p = n ? n.width : 0,
    a = n ? n.height : 0,
    s = p / 2 + o;
  let c = "",
    f = "";
  return i ? (c = {
    start: `${s}px`,
    center: "center",
    end: t.width - s + "px"
  }[r], f = "top" === e ? `${t.height + a}px` : -a + "px") : (c = "left" === e ? `${t.width + a}px` : -a + "px", f = {
    start: `${s}px`,
    center: "center",
    end: t.height - s + "px"
  }[r]), `${c} ${f}`;
}
const o = {
    position: "fixed",
    top: 0,
    left: 0,
    opacity: 0,
    transform: "translate3d(0, -200%, 0)"
  },
  n = {
    position: "absolute",
    opacity: 0
  };
function i(_ref2) {
  let {
    popperSize: t,
    arrowSize: e,
    arrowOffset: r,
    side: o,
    align: n
  } = _ref2;
  const i = (t.width - e.width) / 2,
    a = (t.height - e.width) / 2,
    s = {
      top: 0,
      right: 90,
      bottom: 180,
      left: -90
    }[o],
    c = Math.max(e.width, e.height),
    f = {
      width: `${c}px`,
      height: `${c}px`,
      transform: `rotate(${s}deg)`,
      willChange: "transform",
      position: "absolute",
      [o]: "100%",
      direction: p(o, n)
    };
  return "top" !== o && "bottom" !== o || ("start" === n && (f.left = `${r}px`), "center" === n && (f.left = `${i}px`), "end" === n && (f.right = `${r}px`)), "left" !== o && "right" !== o || ("start" === n && (f.top = `${r}px`), "center" === n && (f.top = `${a}px`), "end" === n && (f.bottom = `${r}px`)), f;
}
function p(t, e) {
  return ("top" !== t && "right" !== t || "end" !== e) && ("bottom" !== t && "left" !== t || "end" === e) ? "ltr" : "rtl";
}
function a(t) {
  return {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[t];
}
function s(t, e) {
  return {
    top: t.top < e.top,
    right: t.right > e.right,
    bottom: t.bottom > e.bottom,
    left: t.left < e.left
  };
}